import * as React from 'react';
import * as classNames from 'classnames';
import * as styles from './styles.scss';
import { Fallback } from 'components/common';
import { IPopUpData } from 'interfaces/reducers';
import { Modal as ReactBootstrapModal } from 'react-bootstrap';
import { handleError } from 'utils/common';
import { withErrorBoundary } from 'react-error-boundary';
import Slider from 'react-slick';
import { HIDE_ADS_POPUP } from 'constants/main';
import { getKey, setKey } from 'utils/localStorage';
import { WithNamespaces, withNamespaces } from 'react-i18next';
import { Lang } from 'constants/enum';

interface IModalSliderProps
  extends React.ClassAttributes<ModalSliderComponent>,
    WithNamespaces {
  readonly show?: boolean;
  readonly size?: 'sm' | 'lg' | 'xl';
  readonly isBackgroundBlur?: boolean;
  readonly className?: string;
  readonly dialogClassName?: string;
  readonly data: IPopUpData;
  readonly selectedAccount?: string;
  readonly currentLang?: string;

  readonly onHide?: () => void;
  readonly onShow?: () => void;
}

interface IModalSliderStates {
  readonly activeTab: number;
  readonly oldSlide: number;
  readonly activeSlide: number;
  // readonly activeSlide2: number;
}

class ModalSliderComponent extends React.Component<
  IModalSliderProps,
  IModalSliderStates
> {
  constructor(props: IModalSliderProps) {
    super(props);
    this.state = {
      activeTab: 0,
      oldSlide: 0,
      activeSlide: 0,
      // activeSlide2: 0,
    };
  }

  componentDidMount() {
    this.validateAdsPopup(this.props.selectedAccount || '');
  }

  private formatAccountNumber = (accountNumber: string | undefined) => {
    if (accountNumber) return accountNumber.slice(0, -2);
    else return '';
  };

  private onHidePopUpIn30Days = async () => {
    this.props.onHide?.();
    const data = {
      [this.formatAccountNumber(
        this.props.selectedAccount
      )]: new Date().getTime(),
    };
    const listAccountHideAdsPopup = await getKey(HIDE_ADS_POPUP);
    if (listAccountHideAdsPopup) {
      setKey(HIDE_ADS_POPUP, Object.assign(listAccountHideAdsPopup, data));
    } else {
      setKey(HIDE_ADS_POPUP, { ...data });
    }
  };

  private validateAdsPopup = async (accountNumber: string) => {
    const today = new Date().getTime();
    const listAccountHideAdsPopup = (await getKey(HIDE_ADS_POPUP)) as {
      [key: string]: number | null;
    };
    if (listAccountHideAdsPopup != null) {
      const timeDifference =
        listAccountHideAdsPopup[accountNumber.slice(0, -2) || ''];

      if (timeDifference) {
        const dayDifference = Math.floor(
          (today - Number(timeDifference)) / (1000 * 3600 * 24)
        );

        if (dayDifference >= 30) {
          setKey(HIDE_ADS_POPUP, {
            ...listAccountHideAdsPopup,
            [this.formatAccountNumber(accountNumber)]: null,
          });
          this.props.onShow?.();
        } else {
          this.props.onHide?.();
        }
      } else {
        this.props.onShow?.();
      }
    }
  };

  render() {
    const { t, data } = this.props;
    const settings = {
      dots: true,
      className: 'sample',
      beforeChange: (current: any, next: any) =>
        this.setState({ oldSlide: current, activeSlide: next }),
      // afterChange: (current: any) => this.setState({ activeSlide2: current }),
    };

    return (
      <>
        <ReactBootstrapModal
          className={classNames(
            styles.ModalSlider,
            { [styles.Blur]: this.props.isBackgroundBlur },
            this.props.className
          )}
          dialogClassName={classNames(
            styles.ModalDialog,
            this.props.dialogClassName
          )}
          show={this.props.show}
          onHide={this.props.onHide}
          centered={true}
          size={this.props.size}
        >
          <div className={styles.CloseButton} onClick={this.props.onHide}>
            {/* <FaTimes size={10} /> */}X
          </div>
          <div className={styles.Swiper}>
            <div
              className={classNames(styles.Navigation, {
                [styles.Active]: this.state.activeTab === 0,
              })}
              onClick={this.handlePreviousTab}
            ></div>
            <div
              className={classNames(styles.Navigation, {
                [styles.Active]:
                  this.state.activeTab >= 1 &&
                  this.state.activeTab < data.listBanner.length - 1,
              })}
              onClick={this.handleMiddleTab}
            ></div>
            <div
              className={classNames(styles.Navigation, {
                [styles.Active]:
                  this.state.activeTab > 1 &&
                  this.state.activeTab === data.listBanner.length - 1,
              })}
              onClick={this.handleNextTab}
            ></div>
          </div>

          <ReactBootstrapModal.Body className={styles.ModalBody}>
            <>
              <Slider {...settings}>
                {data.listBanner.map((item, index) => {
                  return (
                    <div style={{ height: '100%' }} key={index}>
                      <img
                        style={{ width: '100%', height: 450, borderRadius: 20 }}
                        src={
                          this.props.currentLang === Lang.VI
                            ? item.imageVi
                            : item.imageEn
                        }
                      />
                    </div>
                  );
                })}
              </Slider>

              {data.listBanner[this.state.activeSlide].learnMoreLink !== '' && (
                <div
                  onClick={() => {
                    window.open(
                      data.listBanner[this.state.activeSlide].learnMoreLink
                    );
                  }}
                  className={styles.MoreBtn}
                >
                  {this.props.currentLang === Lang.VI
                    ? data.listBanner[this.state.activeSlide].learnMoreLabelVi
                    : data.listBanner[this.state.activeSlide].learnMoreLabelEn}
                </div>
              )}

              {data.Disable30Day && (
                <div
                  onClick={this.onHidePopUpIn30Days}
                  className={styles.HidePopupText}
                >
                  {t('Not show up again for 30 days')}
                </div>
              )}
            </>

            {/* <div
              className={styles.Content}
              style={{
                backgroundImage: `url(${
                  data.listBanner[this.state.activeTab].image
                })`,
                backgroundSize: 'contain',
              }}
            >
              <div className={styles.Title}>
                {data.listBanner[this.state.activeTab].title}
              </div>
              <span>{data.listBanner[this.state.activeTab].description}</span>
              <a
                href={data.listBanner[this.state.activeTab].learnMoreLink}
                target="_blank"
                rel="noreferrer"
              >
                {data.listBanner[this.state.activeTab].learnMoreLabel}
              </a>
            </div> */}
          </ReactBootstrapModal.Body>
        </ReactBootstrapModal>
      </>
    );
  }
  private handlePreviousTab = () => {
    if (this.state.activeTab >= 1) {
      this.setState({ activeTab: this.state.activeTab - 1 });
    } else {
      return;
    }
  };
  private handleMiddleTab = () => {
    if (this.props.data.listBanner.length >= 2) {
      this.setState({ activeTab: 1 });
    } else {
      return;
    }
  };
  private handleNextTab = () => {
    if (this.state.activeTab < this.props.data.listBanner.length - 1) {
      this.setState({ activeTab: this.state.activeTab + 1 });
    } else {
      return;
    }
  };
}

const ModalSlider = withErrorBoundary(
  withNamespaces('common')(ModalSliderComponent),
  Fallback,
  handleError
);

export default ModalSlider;



// WEBPACK FOOTER //
// ./src/components/common/ModalSlider/index.tsx